import { IAbstractRecord } from '@models';
import { IProductionDetailsSummary } from '../../../..';
import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';

export const initialValues = {
  medicalClass: '',
  continuity: '',
  continuityNumber: '',
  exclusion: '',
  remarks: '',
};

export const getInputs = (
  lovs: Record<string, IAbstractRecord> = {},
  values: IProductionDetailsSummary
): IDynamicFormWidgetSection[] => [
  {
    inputs: {
      medicalClass: {
        name: 'medicalClass',
        title: 'Medical Class',
        type: FormFieldType.select,
        placeholder: 'Medical Class',
        value: values?.ExpatDetails?.MedicalClass?.Code,
        required: true,
        selectOptions: lovs?.medicalClasses || {},
        disabled: true,
      },
      continuity: {
        name: 'continuity',
        title: 'Continuity',
        type: FormFieldType.select,
        placeholder: 'Continuity',
        value: values?.ExpatDetails?.Continuity,
        required: false,
        selectOptions: { YES: 'Yes', NO: 'No' },
        hidden: false,
      },
      continuityNumber: {
        name: 'continuityNumber',
        title: 'Continuity Number',
        type: FormFieldType.number,
        placeholder: 'Continuity Number',
        value: values?.ExpatDetails?.ContinuityNumber,
        required: false,
      },
      exclusion: {
        name: 'exclusion',
        title: 'Exclusion',
        type: FormFieldType.textArea,
        placeholder: 'Exclusion',
        value: values?.ExpatDetails?.Exclusion,
        required: false,
      },
      remarks: {
        name: 'remarks',
        title: 'Remarks',
        type: FormFieldType.textArea,
        placeholder: 'Remarks',
        value: values?.ExpatDetails?.Remarks,
        required: false,
      },
    },
  },
];
